export const ORIGINS = {
  BIC: 'Bio',
  REG: 'La région du goût',
  LAB: 'Label Rouge',
  NEW: 'Nouvelle recette du chef',
  SOI: 'Cuisiné par nos soins',
  POC: 'Porc français',
  POF: 'Poisson frais',
  ECP: 'Produit eco',
  BIO: 'Produit bio',
  PRF: 'Produit frais',
  LOC: 'Produit local',
  VEG: 'Produit vege',
  VBF: 'Viande bovine française',
  VOF: 'Volaille française'
};

export const PRODUCT_TYPES = {
  STARTER: "ENT",
  MAIN: "PLA",
  DESSERT: "DES",
  CHEESE: "FRO",
  DRINK: "BOI",
  SIDE: "ACC"
};

export const PRODUCT_TYPES_NAMES = {
  [PRODUCT_TYPES.STARTER]: "Entrée",
  [PRODUCT_TYPES.MAIN]: "Plat",
  [PRODUCT_TYPES.DESSERT]: "Dessert",
  [PRODUCT_TYPES.CHEESE]: "Fromage",
  [PRODUCT_TYPES.DRINK]: "Boisson",
  [PRODUCT_TYPES.SIDE]: "Accompagnement"
};
